/** @format */

import React, { useState, useEffect } from "react";
import { Table, Modal, Spin, notification } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { path, sessionVar } from "../../../utils/common/constant";
import { Button, Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import imglogo from "../../../assets/common/logo_header.webp";

import {
  getprojects,
  deleteprojectbyid,
  getprojectbyid,
} from "../../../services/projects";
import {
  getSessionVar,
  convertStringToArray,
  formatNumber,
} from "../../../utils/common/hashData";
import parse from "html-react-parser";

import { Fancybox } from "../../../components";
import YouTube from "react-youtube";
import { Icon } from "@iconify/react";

const ManageProjects = () => {
  const navigate = useNavigate();
  const user = getSessionVar(sessionVar.user);
  const pagesize = 5;
  const [totalPages, settotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const opts = {
    height: "360",
    width: "100%",
    playerVars: {
      autoplay: 0, // Don't autoplay on load
    },
  };

  useEffect(() => {
    if (!user) {
      navigate("../" + path.common.ADMIN);
    }
  }, []);
  const [projectsData, setprojectsData] = useState([]);
  const [isloadingdata, setIsloadingData] = useState(false);

  const [datadetail, setDatadetail] = useState({
    id: null,
    name: "",
    location: "",
    type: "",
    content: "",
    thumbnail: "",
    pictureUrl: "",
    pictureGallery: "",
    architecture: "",
    scale: "",
    investor: "",
    price: 0,
    website: "",
    completionDate: "",
    status: "",
  });

  const handleEditActivity = (e) => {
    navigate("../" + path.private.EDITPROJECT, { state: e });
  };

  const getblogbyID = async (e) => {
    await getprojectbyid(e)
      .then((res) => {
        setDatadetail(res.data.data);
        setIsModalOpen(true);
      })
      .catch((err) => {
        console.error(err.message);
      });

    setIsModalOpen(true);
  };

  const handledeleteProject = async (id) => {
    await deleteprojectbyid(id)
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Delete successfully !!!",
            duration: 2,
            placement: "topRight",
          });
          navigate("../" + path.private.MANAGEPROJECTS);
          getAllProjects();
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          notification.info({
            message: "Your login session has expired  !!!",
            duration: 3,
            placement: "topRight",
          });
          navigate("../" + path.common.LOGIN);
        } else {
          console.log(err);
        }
      });
  };
  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      key: "name",
      render: (_, name) => (
        <div className="pv:max-md:w-[100px] w-[200px]">
          <p className=" line-clamp-3  text-primary pv:max-ph:text-[12px] text-[1rem]">
            {name.name}
          </p>
        </div>
      ),
    },

    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, thumbnail) => (
        <div className="flex items-center pv:max-ph:w-[100px] w-[300px] justify-center">
          <img
            alt="thumbnail"
            className="w-full h-[150px] pv:max-sm:h-[100px]  object-cover"
            src={thumbnail.thumbnail}
          ></img>
        </div>
      ),
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (_, location) => (
        <p className=" line-clamp-3 text-primary text-[1rem]">
          {location.location}
        </p>
      ),
    },
    {
      title: "Investor",
      dataIndex: "investor",
      key: "investor",
      render: (_, investor) => (
        <p className=" line-clamp-3 text-primary text-[1rem]">
          {investor.investor}
        </p>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, status) => (
        <p
          className={` py-1  w-[120px] text-white text-center text-[1rem] rounded-lg  ${status.status === "Completed" ? "bg-green-500" : "bg-yellow-500"}`}
        >
          {status.status}
        </p>
      ),
    },

    {
      title: "Action",
      key: "action",

      render: (_, record) => (
        <div className="flex  flex-col gap-4 items-center justify-center gap-x-2">
          <Button
            className=" w-[100px] h-fit"
            type="primary"
            onClick={() => {
              getblogbyID(record.id);
            }}
          >
            <p className="">View</p>
          </Button>
          <Button
            className="w-[100px] h-fit"
            onClick={() => {
              handleEditActivity(record);
            }}
          >
            <p className="">Edit</p>
          </Button>

          <Popconfirm
            placement="rightTop"
            title="Confirm Deletion"
            description="Are you sure you want to delete this event?"
            okText="Delete"
            cancelText="Cancel"
            onConfirm={() => {
              handledeleteProject(record?.id);
            }}
            icon={
              <QuestionCircleOutlined
                style={{
                  color: "red",
                }}
              />
            }
          >
            <Button danger className="w-[100px] h-fit">
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const getAllProjects = async () => {
    setIsloadingData(true);
    try {
      const res = await getprojects(currentPage, pagesize);
      setprojectsData(res.data);
      settotalPages(res.metadata.totalProject); // Cập nhật state với dữ liệu hợp lệ
      setIsloadingData(false); // Tắt trạng thái loading
    } catch (err) {
      console.error(err.message);
      setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
    }
  };

  useEffect(() => {
    getAllProjects();
  }, [currentPage]);

  return (
    <div className="container  mx-auto px-4">
      <div className="w-full pvmax:max-ph:w-[280px]  mx-auto h-auto  bg-white shadow-xl rounded-lg p-4 sm:p-6">
        <div className="flex flex-wrap items-center justify-between p-2">
          <p className="text-2xl font-bold text-gray-800">Manage Projects</p>
          <Button
            className="flex items-center gap-x-2 px-4 py-2"
            type="primary"
            onClick={() => navigate("../" + path.private.CREATEPROJECT)}
          >
            <Icon icon="mdi:package-variant-add" width={24} height={24} />
            <span className="text-sm sm:text-base">Create Project</span>
          </Button>
        </div>

        {/* Bảng */}
        <div className="overflow-x-auto">
          {isloadingdata ? (
            <div className="flex justify-center py-6">
              <Spin size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={projectsData}
              loading={isloadingdata}
              pagination={{
                pageSize: pagesize,
                total: totalPages,
                position: ["bottomCenter"],
                current: currentPage,
                onChange: (e) => {
                  setCurrentPage(e);
                },
              }}
              className="w-full overflow-x-auto text-sm sm:text-base"
            />
          )}
        </div>
      </div>

      {/* Modal */}
      <Modal
        title=<div className="flex justify-between ">
          <p className="text-center text-primary"> {datadetail?.name}</p>
          <button
            className=""
            onClick={() => {
              handleCancel();
            }}
          >
            <Icon
              icon={"material-symbols:close"}
              className="h-6 w-6 text-primary"
            ></Icon>
          </button>
        </div>
        open={isModalOpen}
        onOk={handleOk}
        width={isModalOpen ? "80%" : "70%"}
        centered
        onCancel={handleCancel}
        closable={false}
        footer={null}
      >
        <div className="w-full">
          {/* Banner */}
          <div className="relative w-full h-[50vh] md:h-[calc(100vh-132px)] overflow-hidden">
            <img
              src={datadetail?.thumbnail}
              className="absolute w-full h-full object-cover object-bottom"
              alt="Project Banner"
            />
          </div>
          <div className="max-w-[1140px] mx-auto pt-10 w-[80%]  qhd:max-w-[100%] qhd:w-[100%] ">
            {/* Project info basic */}
            <div className="pb-2">
              <div className="">
                <p className=" pb-[1.25rem] pv:max-lg:pb-2 text-[2.5rem] qhd:text-[2.5rem]  font-medium text-primary leading-tight">
                  {datadetail?.name}
                </p>
              </div>
              <div className="">
                <p className="text-[1.125rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed">
                  {datadetail?.location}
                </p>
              </div>
            </div>
            {/* Picture gallery */}
            <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
              <div className="col-span-2 pv:max-lg:col-span-1">
                <Fancybox
                  options={{
                    Carousel: {
                      infinite: false,
                    },
                  }}
                >
                  {convertStringToArray(datadetail?.pictureGallery)?.map(
                    (item, index) => {
                      return (
                        <div
                          className={`overflow-hidden ${index === 0 ? "" : "hidden"}`}
                        >
                          <a className="" data-fancybox="gallery" href={item}>
                            <img
                              src={item}
                              alt="Main"
                              className="cursor-zoom-in w-full md:h-[400px] object-cover rounded-lg "
                            />
                          </a>
                        </div>
                      );
                    }
                  )}
                </Fancybox>
              </div>
              <div className="col-span-1 pv:max-lg:col-span-1">
                <Fancybox
                  options={{
                    Carousel: {
                      infinite: false,
                    },
                  }}
                >
                  <div className=" grid  gap-4 pv:max-lg:grid-cols-2 ">
                    {convertStringToArray(datadetail?.pictureGallery)?.map(
                      (item, index) => {
                        return (
                          <div
                            key={index}
                            className={`rounded-lg ${index === 2 ? "shadow-custom-image " : ""} overflow-hidden ${index === 0 || index >= 3 ? "hidden" : ""}`}
                          >
                            {item ? (
                              <a
                                className="relative"
                                data-fancybox="gallery"
                                href={item}
                              >
                                <img
                                  src={item}
                                  alt={`Thumbnail ${index + 1}`}
                                  className={` cursor-zoom-in w-full h-[192px] rounded-lg  object-cover hover:scale-105 transition-transform duration-300`}
                                />
                                <p
                                  className={`${index === 2 && convertStringToArray(datadetail?.pictureGallery).length > 3 ? "absolute" : "hidden"}  bottom-4 right-4 px-4 py-2  pv:max-ph:py-0  pv:max-ph:right-0  pv:max-ph:bottom-0 bg-white text-primary_light bg-opacity-60 rounded-lg `}
                                >
                                  View more images
                                </p>
                              </a>
                            ) : (
                              <div className="w-full h-[100px] bg-gray-200 flex items-center justify-center">
                                No image
                              </div>
                            )}
                          </div>
                        );
                      }
                    )}
                  </div>
                </Fancybox>
              </div>
            </div>

            {/* Other information */}
            <div className="grid grid-cols-3 gap-4  pv:max-lg:grid-cols-1">
              <div className="col-span-2 pv:max-lg:col-span-1 ">
                <div className="  shadow-custom-activity rounded-lg  my-10 pv:max-lg:my-2  ">
                  <div className="flex h-[100px] items-center pv:max-lg:h-full pv:max-lg:py-2  justify-around  pv:max-lg:flex-col pv:max-lg:gap-2 pv:max-lg:w-[95%] pv:max-lg:mx-auto text-[1rem]">
                    <div className=" pv:max-lg:w-full">
                      <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                        Architecture
                      </p>
                      <div className="flex items-center gap-1">
                        <p className=" whitespace-pre-line text-primary_light text-justify leading-relaxed font-bold">
                          {datadetail?.architecture}
                        </p>
                      </div>
                    </div>
                    <div className="pv:max-lg:w-full">
                      <p className="  whitespace-pre-line text-primary text-justify leading-relaxed ">
                        Scale
                      </p>
                      <div className="flex items-center gap-1">
                        <p className="  text-primary_light font-bold">
                          {datadetail?.scale}
                        </p>
                      </div>
                    </div>
                    <div className=" pv:max-lg:w-full">
                      <p className="   whitespace-pre-line text-primary  leading-relaxed ">
                        Project Type
                      </p>
                      <div className="flex items-center gap-1">
                        <p className="  text-primary_light font-bold">
                          {datadetail?.type}
                        </p>
                      </div>
                    </div>
                    <div className=" pv:max-lg:w-full">
                      <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                        Status
                      </p>
                      <div className="flex items-center gap-1 ">
                        <p className=" text-primary_light font-bold">
                          {datadetail?.status}
                        </p>
                      </div>
                    </div>
                    <div className=" pv:max-lg:w-full">
                      <p className="    whitespace-pre-line text-primary text-justify leading-relaxed ">
                        Date
                      </p>
                      <div className="flex items-center gap-1 ">
                        <p className=" text-primary_light font-bold">
                          {datadetail?.completionDate}
                        </p>
                      </div>
                    </div>
                    {/* project Type Mobile */}
                    <div className=" pv:max-lg:w-full lg:hidden">
                      <p className=" whitespace-pre-line text-primary text-justify leading-relaxed ">
                        Total investments
                      </p>
                      <div className="flex items-center gap-1 ">
                        <p className=" text-primary_light font-bold">
                          {formatNumber(datadetail?.price)} Billions
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-1 pv:max-lg:hidden  ">
                <div className="shadow-custom-activity  rounded-lg h-[100px] my-10 pv:max-lg:my-2 flex flex-col  p-2  justify-center ">
                  <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary leading-relaxed ">
                    Total investments
                  </p>
                  <p className="text-primary_light text-[2rem]">
                    {formatNumber(datadetail?.price)} Billions
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
              <div className="col-span-2 pv:max-lg:grid-cols-1 ">
                <div className="">
                  <div className="ProseMirror text-primary">
                    {parse(datadetail?.content)}
                  </div>
                </div>
                <div className="mt-6 p-[10px]">
                  <div className="w-full ">
                    <YouTube
                      videoId={datadetail?.pictureUrl}
                      opts={opts}
                      className="w-full h-full"
                    />
                  </div>
                </div>
              </div>
              <div className="">
                <div className=" pv:max-lg:w-full ">
                  <div className="col-span-1 shadow-custom-activity h-[180px]    rounded-lg py-[20px] flex gap-2 items-center  ">
                    <div className="p-4 m-2 rounded-lg bg-primary/5">
                      <img
                        className="h-[120px] pv:max-md:h-[80px] "
                        src={imglogo}
                      ></img>
                    </div>
                    <div className="">
                      <div className="">
                        <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Investor
                        </p>
                        <p className="text-[1rem] text-primary_light">
                          {datadetail?.investor}
                        </p>
                      </div>
                      <div className="flex gap-2 text-base text-primary_light items-center">
                        <Icon icon={"ic:outline-phone"}></Icon>
                        <p className="">+ 61 411 896 553</p>
                      </div>
                      <div className="flex gap-2 text-base text-primary_light items-center">
                        <Icon icon={"ic:outline-email"}></Icon>
                        <p className="">info@idg-global.com</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ManageProjects;
